const UNIVERSAL = {
  BASEURL: process.env.REACT_APP_API_URL || "http://localhost:7008/",
};
export default UNIVERSAL;
